export enum HighlightType {
  RELEASE,
  FEATURE,
  DOCUMENTATION,
  WIDGET,
  ENHANCEMENT,
}

export interface NewsHighlight {
  id: string;
  title: string;
  description: string;
  link?: string;
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
  imageAlt?: string;
  tags?: HighlightType[];
}

export const HighlightsBase: Partial<NewsHighlight>[] = [
  {
    id: '12',
    link: '/docs/user-guide/events/#ongoing-maintenances',
    tags: [HighlightType.FEATURE],
  },
  {
    id: '11',
    link: '/docs/user-guide/explore/#waterfall-har',
    tags: [HighlightType.ENHANCEMENT],
    image: 'har-viewer.webp',
    imageWidth: 313,
    imageHeight: 200,
  },
  {
    id: '10',
    link: '/docs/user-guide/agentic-ai-mcp/',
    tags: [HighlightType.FEATURE],
  },
  {
    id: '9',
    link: '/docs/user-guide/scoring/#all-state-percentage-columns',
    tags: [HighlightType.ENHANCEMENT],
  },
  {
    id: '8',
    link: '/docs/user-guide/script-complex-measure/#actions-group',
    tags: [HighlightType.FEATURE],
    image: 'action-group.png',
    imageWidth: 188,
    imageHeight: 50,
  },
  {
    id: '7',
    link: '/docs/user-guide/script-complex-measure/#version-management',
    tags: [HighlightType.FEATURE],
    image: 'versionning.png',
    imageWidth: 266,
    imageHeight: 120,
  },
  {
    id: '6',
    tags: [HighlightType.ENHANCEMENT],
    image: 'forms-enhancement.jpg',
    imageWidth: 383,
    imageHeight: 150,
  },
  {
    id: '5',
    link: '/docs/user-guide/dashboards/widgets/catalog/states-grid/',
    tags: [HighlightType.WIDGET],
    image: 'states-grid.jpg',
    imageWidth: 407,
    imageHeight: 150,
  },
  {
    id: '4',
    link: '/docs/user-guide/authentication/#two-factor-authentication-totp',
    tags: [HighlightType.FEATURE],
  },
  {
    id: '3',
    link: '/docs/user-guide/dashboards/widgets/catalog/consecutive-states/',
    tags: [HighlightType.WIDGET],
    image: 'consecutive-states.jpg',
    imageWidth: 392,
    imageHeight: 200,
  },
  {
    id: '2',
    link: '/docs/user-guide/dashboards/playlists/',
    tags: [HighlightType.FEATURE],
    image: 'playlist.png',
  },
  {
    id: '1',
    link: '/docs/user-guide/dashboards/',
    tags: [HighlightType.DOCUMENTATION],
  },
];
